






























































































































































































import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    my_getSystemImg(number_state:any){
        let url = number_state=='上升'?utils.getSystemImg({name:'iconup'}):utils.getSystemImg({name:'icondown'})
        return url;
    }
}
